import { isWarnable } from '../restApi/labels/LabelTypes';
import { openDataQualityDialogCatalog } from '../sagas/dataQuality/SetDataQualitySaga';


export type RenderDataQualityDialogParams = {
  readonly content: {
    readonly contentId: string;
    readonly contentName: string;
    readonly contentType: string;
  };
  readonly dismiss: () => void;
}

export function renderDataQualityDialog(params: RenderDataQualityDialogParams): Promise<unknown> {
  const { contentId, contentName, contentType } = params.content;
  if (!isWarnable(contentType)) {
    return null;
  }

  return openDataQualityDialogCatalog({
    contentItem: {
      contentName,
      contentId,
      contentType,
    },
    onSubmit: params.dismiss,
  });
}
